/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Sonderurlaub1Inputs */



/**

* @param {_Class_Sonderurlaub1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_sonderurlaub1 = /** @type {((inputs?: _Class_Sonderurlaub1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Sonderurlaub1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Sonderurlaub §29 TVöD")
});
export { _class_sonderurlaub1 as "_class_Sonderurlaub" }